import { TrendingUp } from "lucide-react";

export default function SiteFrame({ site, client, industry, testId }) {
  return (
    <div
      data-testid={testId}
      className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
    >
      <div className="flex items-center gap-2 border-b border-slate-200 bg-slate-100 px-4 py-2.5">
        <span className="flex shrink-0 gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-[#EF4444]/70" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#FACC15]/80" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#14B8A6]/80" />
        </span>
        <span
          data-testid={`${testId}-url`}
          className="ml-1 flex-1 truncate rounded-full bg-white px-3 py-1 font-mono text-[11px] uppercase tracking-[0.14em] text-faint"
        >
          {site ? site.url : `${client} — ${industry}`}
        </span>
        <span className="shrink-0 font-mono text-[11px] uppercase tracking-[0.14em] text-faint">
          {site ? (site.stock ? "Illustrative photo" : "Client website") : "Project preview"}
        </span>
      </div>
      {site ? (
        <img
          src={site.img}
          alt={`${client} website project`}
          loading="lazy"
          className="block h-auto w-full"
        />
      ) : (
        <div className="relative flex aspect-[16/9] flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-[#0B0F19] via-slate-900 to-[#0B0F19] text-center">
          <TrendingUp className="h-8 w-8 text-flame" />
          <div className="mt-4 px-6 font-display text-2xl font-bold tracking-tight text-slate-100">
            {client}
          </div>
          <div className="mt-2 px-6 font-mono text-[12px] uppercase tracking-[0.25em] text-slate-400">
            {industry}
          </div>
        </div>
      )}
    </div>
  );
}
